import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Flex, Icon, Text } from "@nubeteck/components";
import { FlexStyled } from "../../../components/registration/register-confirmation/confirmation.styled";
import {
  ButtonAlternativeStyled,
  ButtonPrimaryStyled,
  ButtonsContainer,
} from "../../../components/custom/buttons/buttons.styled";
import {
  SectionHeaderStyled,
  SmallHeadingStyled,
} from "../../../components/custom/texts/texts.styled";
import { Bill, CardsGroup, RegisterSteps, ResumeList, ScrollView } from "../../../components";
import toast from "react-hot-toast";
import { BillBoxStyled } from "../../../components/billing/bill/bill.styled";
import { Card, Checkbox, Image, MenuProps, Modal, Segmented, Skeleton } from "antd";
import {
  DropdownSubIcon,
  ResumeCardStyled,
  ResumeFlexStyled,
} from "../../../components/billing/resume-card/resumeCard.styled";
import {
  useDeleteCartItemMutation,
  useGetCartMutation,
  useGetCartTermsMutation,
  useGetIsThereAPaymentInProcessMutation,
  useGetPaymentInfoMutation,
  useGetPowerTranzPlansQuery,
  useCompletePowerTranzPaymentMutation,
  useSaveBillMutation,
  useSaveInvoicePersonDataMutation,
} from "src/services/cartServices";
import { IPowerTranzPlan } from "src/Interfaces/options";
import useManageTimer from "src/hooks/useManageTimer";
import {
  toastErrorStyle,
  toastSuccessStyle,
  toastWarningStyle,
  useSuccessOperationCompletedToast,
  useErrorGenericToast,
  useSuccessPaymentCompletedToast,
} from "src/constants";
import { ICartItem } from "@/Interfaces/cart";
import { themeColors } from "src/core";
import {
  CartHeadingStyled,
  CartResumeContainerStyled,
  FeesContainerStyled,
  ImageButtonContainerStyled,
} from "./cart.styled";
import {
  CardText,
  CardTitle,
  CardUserInvoiceName,
} from "src/components/reports/cards/report-cards.styled";
import { FormatterUtils } from "@nubeteck/utils";
import { useSelector } from "react-redux";
import { PaymentSVG } from "src/assets";
import { RootState } from "@/core/store/store";
import { useMediaQuery } from "src/hooks";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useNavigate, useParams } from "react-router-dom";
import { useAssignCartToCashierMutation } from "src/services/chargesSettingsServices";
import ThirdPersonForm from "./third-person-form";
import CreditCardForm from "./credit-card-form";
import ThreeDSModal from "./three-ds-modal";
import BacSimplePayForm from "./bac-simple-pay-form";
import PaymentMethodSelector, { PaymentMethod } from "./payment-method-selector";
import { ChangeCurrencyButtonStyled } from "./payment-method-selector.styled";
import parse from "html-react-parser";
import { getIsUserImpersonated } from "src/utils";
import { formatDate, isDisplayableDate } from "src/utils/date-util";
import CartMoneyInfo from "src/components/billing/cart-money-info/cart-money-info";
import { getBoxStudentPage } from "../../../Api/content";
import { getUserEnrollementPage, getEnrollmentPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";

// PowerTranz SPI-3DS: El comercio captura datos de tarjeta y maneja 3DS via iframe

interface IRegisterStepProps {
  id: number;
  title: string;
  component: JSX.Element;
}
interface IFees {
  id: number;
  descripcion: string;
  saldo: number;
  moneda: number;
  fechaVencimiento: string;
}

export const Payments = () => {
  const { locale } = useLocale();
  const [boxStudentPage, setBoxStudentPage] = useState<any>(null);
  const { userInfo } = useSelector((state: RootState) => state.user);
  const [modal, contextHolder] = Modal.useModal();
  const [totalPendiente, setTotalPendiente] = useState({ colones: 0, dolares: 0 });
  const [totalCuotas, setTotalCuotas] = useState(0);
  const [currentStep, setCurrentStep] = React.useState<number>(0);
  const [totalAmountCol, setTotalAmountCol] = useState(0);
  const [totalAmountDol, setTotalAmountDol] = useState(0);
  const [cargosMonedas, setCargosMonedas] = useState({ colones: false, dolares: false });
  const [cuotasPasadas, setCuotasPasadas] = useState<IFees[]>([]);
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [modalInvoiceData, setModalInvoiceData] = useState(false);
  const [userEnrollementPage, setUserEnrollementPage] = useState<any>(null);
  const [enrollmentPage, setEnrollmentPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);

  const showSuccessOperationCompletedToast = useSuccessOperationCompletedToast();
  const showErrorGenericToast = useErrorGenericToast();
  const showSuccessPaymentCompletedToast = useSuccessPaymentCompletedToast();

  const [paymentStarted, setPaymentStarted] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>("card");
  const [selectedCurrency, setSelectedCurrency] = useState<number | null>(null);
  const [showCardForm, setShowCardForm] = useState(false);
  const [showBacForm, setShowBacForm] = useState(false);
  const [iframeContent, setIframeContent] = useState<string | null>(null);
  const [pendingSpiToken, setPendingSpiToken] = useState<string | null>(null);
  const [pendingCurrency, setPendingCurrency] = useState<number>(0);
  const [selectedPlanPago, setSelectedPlanPago] = useState<string>("");
  const [chargeAmount, setChargeAmount] = useState<number>(0);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setUserEnrollementPage(null);
        setEnrollmentPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    const loadContent = async () => {
      try {
        const [userEnrollementRes, enrollmentRes] = await Promise.all([
          getUserEnrollementPage(locale),
          getEnrollmentPage(locale)
        ]);
        
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(userEnrollementRes?.data?.attributes || userEnrollementRes?.data || userEnrollementRes);
          setEnrollmentPage(enrollmentRes?.data?.attributes || enrollmentRes?.data || enrollmentRes);
          setIsLoadingContent(false);
        }
      } catch (error) {
        if (!cancel) {
          clearTimeout(timeoutId);
          setUserEnrollementPage(null);
          setEnrollmentPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      }
    };
    
    loadContent();
    
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  const isMobile = useMediaQuery("(max-width: 768px)");

  const [getCart, { data: cartInfo, isLoading, error: errorGet }] = useGetCartMutation();
  const [getPaymentInProcess, { isLoading: isLoadingGettingPaymentInProcess }] =
    useGetIsThereAPaymentInProcessMutation();
  const [getCartTerms, { data: cartTerms }] = useGetCartTermsMutation();
  const [getPaymentInfo, { data: paymentData, isLoading: isLoadingPaymentInfo }] =
    useGetPaymentInfoMutation();
  const [completePowerTranzPayment, { isLoading: isLoadingCompletingPayment }] =
    useCompletePowerTranzPaymentMutation();
  const { data: paymentPlansData, isLoading: isLoadingPaymentPlans } = useGetPowerTranzPlansQuery();
  const paymentPlans: IPowerTranzPlan[] = paymentPlansData?.data ?? [];
  const [saveCart, { isLoading: isLoadingPayment, error: errorPayment }] = useSaveBillMutation();
  const { getTimer, timeLeft, extend, isonHours, hoursToExtend, hoursForPresential } =
    useManageTimer(false, false);
  const [
    deleteItem,
    { isLoading: isLoadingDeleting, isSuccess: isSuccessDeleting, isError: isErrorDeleting },
  ] = useDeleteCartItemMutation();
  const [
    savePerson,
    { isLoading: isLoadingSavingPerson, isSuccess: isSuccesSavingPerson, error: errorSavingPerson },
  ] = useSaveInvoicePersonDataMutation();
  const [
    AssignCartToCashier,
    {
      isLoading: isLoadingCartToCashier,
      isSuccess: isSuccesCartToCashier,
      error: errorCartToCashier,
    },
  ] = useAssignCartToCashierMutation();

  const [materiasCuotas, setMateriasCuotas] = useState<Array<{ id: number; costo: number }>>([]);
  // Si paga asignaturas en cuotas del sistema, no se ofrecen las cuotas tasa cero del banco
  const availablePaymentPlans = useMemo(
    () => (materiasCuotas.length > 0 ? paymentPlans.filter((p) => p.key === "CTDO") : paymentPlans),
    [materiasCuotas, paymentPlans],
  );
  const [form, setForm] = useState<any>({
    saldoAFavorAUsarColones: 0,
    saldoAFavorAUsarDolar: 0,
    cantidadCuotas: 0,
    montoTransferencia: 0,
    monedaTransferencia: 0,
  });

  const { previous } = useParams();
  const navigate = useNavigate();

  // formRef ya no se necesita con PowerTranz (se usaba para el form de Alignet)
  const [modalTerminos, contextHolderTerminos] = Modal.useModal();

  const isUserImpersonated = getIsUserImpersonated(localStorage.getItem("token") ?? "");
  // const isUserImpersonated = getIsUserImpersonated(localStorage.getItem("token") ?? "");

  useEffect(() => {
    const tempMatCuotas = cartInfo?.data?.matriculasCuotas?.map((mat: any) => ({
      id: mat.matriculaId,
      costo: mat.costo,
    }));
    if (JSON.stringify(tempMatCuotas ?? []) !== JSON.stringify(materiasCuotas ?? []))
      getCart({ materiasCuotas: materiasCuotas?.map((mat) => mat.id) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materiasCuotas]);

  useEffect(() => {
    getCart({ materiasCuotas: materiasCuotas?.map((mat) => mat.id) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessDeleting]);

  useEffect(() => {
    getCartTerms();
  }, [getCartTerms]);

  useEffect(() => {
    setTotalCuotas(materiasCuotas.map((mat) => mat.costo).reduce((prev, next) => prev + next, 0));
  }, [materiasCuotas]);

  const getCuotasPasadas: (saldos: IFees[]) => IFees[] = (saldos) => {
    let saldosParaFiltrar = saldos;
    const result: IFees[] = [];
    saldos?.map((saldo) => {
      const saldosCodigoYFechaSimilar = saldosParaFiltrar.filter(
        (s) => s.descripcion == saldo.descripcion && s.fechaVencimiento == saldo.fechaVencimiento,
      );
      const sumaSaldos = saldosCodigoYFechaSimilar.reduce((previous, current) => {
        saldosParaFiltrar = saldosParaFiltrar.filter((sa) => sa.id !== current.id);
        return previous + current.saldo;
      }, 0);
      if (saldosCodigoYFechaSimilar.length > 0) result.push({ ...saldo, saldo: sumaSaldos });
    });
    return result;
  };

  useEffect(() => {
    if (cartInfo?.data?.matriculasCuotas)
      setMateriasCuotas(
        cartInfo?.data?.matriculasCuotas?.map((mat: any) => ({
          id: mat.matriculaId,
          costo: mat.costo,
        })),
      );
    setCuotasPasadas(getCuotasPasadas(cartInfo?.data?.saldosNoVencidos));
    if (
      cartInfo?.data?.asignaturas?.length === 0 &&
      cartInfo?.data?.servicios?.length === 0 &&
      (cartInfo?.data?.colones?.deuda?.saldoNoVencido > 0 ||
        cartInfo?.data?.colones?.deuda?.saldoVencido > 0 ||
        cartInfo?.data?.dolares?.deuda?.saldoNoVencido > 0 ||
        cartInfo?.data?.dolares?.deuda?.saldoVencido > 0)
    ) {
      setCurrentStep(1);
    }
    const infoColones = cartInfo?.data?.colones;
    const infoDolares = cartInfo?.data?.dolares;

    setTotalPendiente({
      colones:
        infoColones?.deuda?.costoTotal -
        infoColones?.descuento?.totalDescuentoBeca -
        infoColones?.descuento?.totalDescuentoPatrocinio,
      dolares:
        infoDolares?.deuda?.costoTotal -
        infoDolares?.descuento?.totalDescuentoBeca -
        infoDolares?.descuento?.totalDescuentoPatrocinio,
    });

    if (
      ((!cartInfo?.data?.asignaturas && !cartInfo?.data?.servicios) ||
        (cartInfo?.data?.asignaturas?.length == 0 && cartInfo?.data?.servicios?.length == 0)) &&
      cartInfo?.data?.colones?.deuda?.saldoNoVencido == 0 &&
      cartInfo?.data?.dolares?.deuda?.saldoNoVencido == 0 &&
      cartInfo?.data?.colones?.deuda?.saldoVencido == 0 &&
      cartInfo?.data?.dolares?.deuda?.saldoVencido == 0
    ) {
      //con el segmented:
      setCargosMonedas({ colones: true, dolares: false });
    } else {
      //Sin el segmented
      setCargosMonedas({
        colones:
          infoColones?.deuda?.saldoNoVencido > 0 ||
          infoColones?.deuda?.saldoVencido > 0 ||
          cartInfo?.data?.asignaturas?.find((as: ICartItem) => as.monedaId == 2) !== undefined ||
          cartInfo?.data?.servicios?.find((ser: ICartItem) => ser.monedaId == 2) !== undefined,
        dolares:
          infoDolares?.deuda?.saldoNoVencido > 0 ||
          infoDolares?.deuda?.saldoVencido > 0 ||
          cartInfo?.data?.asignaturas?.find((as: ICartItem) => as.monedaId == 1) !== undefined ||
          cartInfo?.data?.servicios?.find((ser: ICartItem) => ser.monedaId == 1) !== undefined,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartInfo]);

  useEffect(() => {
    if (errorPayment) {
      toast.error(errorPayment?.data?.message, toastErrorStyle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorPayment]);

  useEffect(() => {
    if (errorGet) {
      toast.error(errorGet?.data?.message, toastErrorStyle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorGet]);

  useEffect(() => {
    if (errorSavingPerson) {
      toast.error(errorSavingPerson?.data?.message, toastErrorStyle);
    }
    if (isSuccesSavingPerson) {
      showSuccessOperationCompletedToast();
      getCart({ materiasCuotas: materiasCuotas?.map((mat) => mat.id) });
      setModalInvoiceData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorSavingPerson, isSuccesSavingPerson]);

  useEffect(() => {
    if (errorCartToCashier) {
      toast.error(errorCartToCashier?.data?.message, toastErrorStyle);
    }
    if (isSuccesCartToCashier) {
      toast.success(
        <div>
          <h3 style={toastSuccessStyle.style}>
            {boxStudentPage?.cashier_success_title ||
              "¡Operación realizada correctamente! El pago será procesado por el cajero(a)."}
          </h3>

          <p>
            {boxStudentPage?.time_extended_prefix || "El tiempo que tiene para pagar ha sido extendido a"}{" "}
            {hoursForPresential} {boxStudentPage?.time_extended_suffix || "hora(s)."}
          </p>

          {cartInfo?.data?.colones?.deuda?.saldoVencido > 0 ||
          cartInfo?.data?.dolares?.deuda?.saldoVencido > 0 ? (
            <p style={{ ...toastWarningStyle.style, width: "auto" }}>
              {boxStudentPage?.overdue_balance_warning ||
                "Si tiene alguna duda respecto a su saldo vencido, comuníquese con el departamento financiero."}
            </p>
          ) : null}
        </div>,

        { duration: 8000 },
      );
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCartToCashier, isSuccesCartToCashier]);

  useEffect(() => {
    if (isErrorDeleting) {
      showErrorGenericToast();
    }
    if (isSuccessDeleting) {
      showSuccessOperationCompletedToast();
    }
  }, [isSuccessDeleting, isErrorDeleting, showErrorGenericToast, showSuccessOperationCompletedToast]);

  useEffect(() => {
    if (paymentData?.data) {
      if (paymentData.data.frictionless) {
        // Flujo frictionless: 3DS ya completó, llamar CompletarPago directamente
        setShowCardForm(false);
        const token = paymentData.data.spiToken;
        if (token) {
          completePowerTranzPayment({
            spiToken: token,
            planPago: selectedPlanPago,
          })
            .then((result: any) => {
              if (result?.data?.data?.estado === "Aprobado") {
                toast.success(boxStudentPage?.payment_success_message || "Pago realizado correctamente", toastSuccessStyle);
                navigate(`/last-receipt/${result.data.data.pagoId}/${null}`);
              } else {
                const mensaje =
                  result?.data?.data?.mensaje || boxStudentPage?.payment_rejected_message || "El pago fue rechazado por la entidad bancaria";
                navigate(`/payment-error/${encodeURIComponent(mensaje.replaceAll(" ", "-"))}`);
                setPaymentStarted(false);
              }
            })
            .catch(() => {
              toast.error(boxStudentPage?.payment_error_message || "Error al completar el pago", toastErrorStyle);
              setPaymentStarted(false);
            });
        }
      } else if (paymentData.data.redirectData) {
        // Flujo challenge: Mostrar el HTML de 3DS en un iframe
        sessionStorage.setItem("powerTranzOrderId", paymentData.data.orderIdentifier);
        sessionStorage.setItem("powerTranzSpiToken", paymentData.data.spiToken);
        sessionStorage.setItem("powerTranzPlanPago", selectedPlanPago);
        setPendingSpiToken(paymentData.data.spiToken);
        setIframeContent(paymentData.data.redirectData);
        setShowCardForm(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData]);

  // Escuchar el postMessage del iframe cuando el 3DS challenge completa
  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type === "POWERTRANZ_3DS_COMPLETE") {
        setIframeContent(null);

        // El callback del backend ya procesó el pago y envía el resultado
        if (event.data.estado === "aprobado") {
          toast.success(boxStudentPage?.payment_success_message || "Pago realizado correctamente", toastSuccessStyle);
          navigate(`/last-receipt/${event.data.pagoId}/${null}`);
          return;
        } else if (event.data.estado === "rechazado") {
          const mensaje = event.data.mensaje || boxStudentPage?.payment_rejected_message || "El pago fue rechazado por la entidad bancaria";
          navigate(`/payment-error/${encodeURIComponent(mensaje.replaceAll(" ", "-"))}`);
          setPaymentStarted(false);
          return;
        } else if (event.data.estado === "error") {
          const mensaje =
            event.data.mensaje ||
            boxStudentPage?.payment_bank_error_message ||
            "Ocurrió un error al procesar el pago con la entidad bancaria";
          navigate(`/payment-error/${encodeURIComponent(mensaje.replaceAll(" ", "-"))}`);
          setPaymentStarted(false);
          return;
        }

        // Fallback: si no hay estado (compatibilidad), intentar completar manualmente
        const token = pendingSpiToken || sessionStorage.getItem("powerTranzSpiToken");
        const planPago = selectedPlanPago || sessionStorage.getItem("powerTranzPlanPago") || "";
        if (token) {
          try {
            const result: any = await completePowerTranzPayment({
              spiToken: token,
              planPago,
            });
            if (result?.data?.data?.estado === "Aprobado") {
              toast.success(boxStudentPage?.payment_success_message || "Pago realizado correctamente", toastSuccessStyle);
              navigate(`/last-receipt/${result.data.data.pagoId}/${null}`);
            } else {
              const mensaje =
                result?.data?.data?.mensaje || boxStudentPage?.payment_rejected_message || "El pago fue rechazado por la entidad bancaria";
              navigate(`/payment-error/${encodeURIComponent(mensaje.replaceAll(" ", "-"))}`);
              setPaymentStarted(false);
            }
          } catch {
            toast.error(boxStudentPage?.payment_error_message || "Error al completar el pago", toastErrorStyle);
            setPaymentStarted(false);
          }
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingSpiToken]);

  const itemsSubjects: (data: any) => MenuProps["items"] = (data) => [
    {
      key: "1",
      label: boxStudentPage?.delete_option_label || "Eliminar",
      icon: <DropdownSubIcon name="" color="#c4c1c1" />,
      onClick: () => {
        confirmDelete(
          { itemId: data.seccionId, esAsignatura: true },
          data.nombre,
          data.matriculaId,
        );
      },
    },
  ];

  const itemsServices: (data: any) => MenuProps["items"] = (data) =>
    !data.esObligatorio
      ? [
          {
            key: "2",
            label: boxStudentPage?.delete_option_label || "Eliminar",
            icon: <DropdownSubIcon name="" color="#c4c1c1" />,
            onClick: () => {
              confirmDelete({ itemId: data.solicitudId, esAsignatura: false }, data.nombre);
            },
          },
        ]
      : undefined;

  const mostrarTerminos = () => {
    const termsArray = cartTerms ? cartTerms.split('-') : [];
    const selectedTerms = locale === 'en' ? termsArray[1] : termsArray[0] || '';
    
    modalTerminos.info({
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> :boxStudentPage?.subtitleT ||(`Términos y condiciones`),

      content: (
        <ScrollView height="500px">
          <div>{parse(selectedTerms)}</div>
        </ScrollView>
      ),
      okText: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (boxStudentPage?.close_button || "Cerrar"),
      style: { top: 50 },
    });
  };

  const confirmDelete = (data: any, name: string, matriculaId?: number) => {
    modal.confirm({
      title: `${boxStudentPage?.remove_item_title_prefix || "Remover"} ${data.esAsignatura ? "asignatura" : "servicio"}`,
      icon: <Icon name="" color="#FFC53D" />,
      content: `${boxStudentPage?.remove_item_content_prefix || "¿Es seguro que desea remover de la factura"} ${
        data.esAsignatura ? "la asignatura" : "el servicio"
      } ${name}?`,
      okText: boxStudentPage?.ok_button || "Aceptar",
      onOk: () => {
        deleteItem(data);
        setMateriasCuotas(materiasCuotas?.filter((mat) => mat.id !== matriculaId));
      },
      cancelText: boxStudentPage?.cancel_button || "Cancelar",
      style: { top: 200 },
    });
  };
  const getTimeLeft = () => {
    if (
      currentStep !== 2 &&
      timeLeft !== 0 &&
      (cartInfo?.data?.asignaturas?.length > 0 || previous == "selection")
    ) {
      return (
        <RegisterSteps
          currentStep={currentStep + 2}
          steps={[{ title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (enrollmentPage?.subtitleO || "Inicio") }, { title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (enrollmentPage?.subtitleT || "Selección de materias") }].concat(
            steps.map((st) => (st.id !== 2 ? { title: st.title } : null)!),
          )}
          getExternalTimer={() => getTimer()}
        />
      );
    }
    return <></>;
  };

  const getPresentialPaymentVisible = () => {
    if (totalAmountCol > 0.1 || totalAmountDol > 0.1) return true;
  };

  const obtenerValidaciones = async (currency: number, method: PaymentMethod) => {
    const validacionPagoEnProceso = await getPaymentInProcess().then((res: any) => {
      if (res?.data?.data === false) {
        return true;
      } else {
        return false;
      }
    });

    const total = currency === 188 ? totalAmountCol : totalAmountDol;
    const pendiente = currency === 188 ? totalPendiente.colones : totalPendiente.dolares;
    const saldoAFavorAUsar =
      currency === 188 ? form.saldoAFavorAUsarColones : form.saldoAFavorAUsarDolar;

    let error = null;
    if (!aceptaTerminos)
      error = boxStudentPage?.terms_required_message || "Debe aceptar los términos para poder efectuar el pago.";

    if (error === null) {
      if (!validacionPagoEnProceso) {
        modal.confirm({
          title:
            boxStudentPage?.payment_in_process_title ||
            `Usted cuenta con un pago que aún está en proceso. Por favor, espere a que termine de ser procesado.`,
          icon: <Icon name="" color="#FFC53D" />,
          content:
            boxStudentPage?.payment_in_process_content ||
            `¿Está seguro(a) de que desea continuar y realizar un nuevo pago?`,
          okText: boxStudentPage?.continue_button || "Continuar",
          onOk: () => {
            realizarPago(total, pendiente, saldoAFavorAUsar, currency, method);
          },
          cancelText: boxStudentPage?.cancel_button || "Cancelar",
          style: { top: 200 },
        });
      } else {
        realizarPago(total, pendiente, saldoAFavorAUsar, currency, method);
      }
    } else {
      toast(error, toastErrorStyle);
    }
  };

  const realizarPago = (
    total: number,
    pendiente: number,
    saldoAFavorAUsar: number,
    monedaId: number,
    method: PaymentMethod,
  ) => {
    setPaymentMethod(method);
    setPaymentStarted(true);

    saveCart({
      saldoAFavorAUsar: saldoAFavorAUsar,
      cantidadCuotas:
        cartInfo?.data?.numeroCuotas >= 1 && materiasCuotas.length > 0
          ? cartInfo?.data?.numeroCuotas
          : 0,
      saldoNoVencidoAPagar: total - pendiente > 0 ? total - pendiente : 0,
      totalPago: total.toFixed(2),
      totalPagoTransferencia: form.montoTransferencia.toFixed(2),
      monedaId,
      monedaTransferencia: form.monedaTransferencia,
      matriculasEnCuotasInt: materiasCuotas.map((mat) => mat.id),
    }).then((res: any) => {
      if (res?.data?.responseStatus == "Success") {
        if (total < 0.1) {
          showSuccessPaymentCompletedToast();
          navigate(`/last-receipt/${cartInfo?.data?.pagoIdActual}/${null}`);
        } else {
          setPendingCurrency(monedaId);
          // Congelamos el monto a cobrar en este momento: totalAmountCol/Dol siguen
          // vivos y pueden cambiar (p.ej. por un refetch del carrito tras guardar el
          // pago) mientras el modal está abierto, lo que dejaba el modal mostrando
          // y cobrando ₡0 aunque el usuario acabara de indicar un monto real.
          setChargeAmount(total);
          if (method === "bac") {
            setShowBacForm(true);
          } else {
            // SPI-3DS: Mostrar formulario de tarjeta antes de llamar a PowerTranz
            setShowCardForm(true);
          }
        }
      }
    });
  };

  const handleCardSubmit = (data: {
    cardPan: string;
    cardCvv: string;
    cardExpiration: string;
    cardholderName: string;
    planPago: string;
  }) => {
    setSelectedPlanPago(data.planPago);
    const total = chargeAmount;
    getPaymentInfo({
      monto: `${total}`,
      moneda: pendingCurrency,
      people: userInfo.id,
      cardPan: data.cardPan,
      cardCvv: data.cardCvv,
      cardExpiration: data.cardExpiration,
      cardholderName: data.cardholderName,
      planPago: data.planPago,
    });
  };

  const getExtendButton = () => {
    return !isonHours &&
      timeLeft !== 0 &&
      cartInfo?.data?.asignaturas?.length > 0 &&
      hoursToExtend !== 0 ? (
      <Button
        style={{ display: "flex", alignItems: "flex-start" }}
        onClick={extend}
        size="large"
        icon={<Icon name="" color={themeColors.colorAccent} />}
      >
        {boxStudentPage?.extend_button_prefix || "Reservar Matrícula por"} {hoursToExtend}{" "}
        {boxStudentPage?.extend_button_suffix || "horas"}
      </Button>
    ) : null;
  };

  const marcarParaCuotas = (matriculaId: number, costo: number) => {
    if (materiasCuotas?.find((mat) => mat.id === matriculaId)) {
      setMateriasCuotas(materiasCuotas?.filter((mat) => mat.id !== matriculaId));
    } else {
      setMateriasCuotas(materiasCuotas?.concat([{ id: matriculaId, costo }]));
    }
  };

  const changePastFeesGettingPaid = (monto: number, moneda: number) => {
    if (cuotasPasadas?.length > 0) {
      let resto = monto;
      const cuotasTemp: IFees[] = [];
      const saldosNoVencidos = getCuotasPasadas(cartInfo?.data?.saldosNoVencidos);

      saldosNoVencidos?.forEach((fee: IFees) => {
        let saldo = fee.saldo;
        if (resto > 0 && fee.moneda === moneda) {
          saldo = saldo - resto;
          if (saldo < 0) {
            resto = saldo * -1;
            saldo = 0;
          } else {
            resto = 0;
          }
        }
        cuotasTemp.push({ ...fee, saldo });
      });

      setCuotasPasadas(cuotasTemp);
    }
  };

  useEffect(() => {
    let cancel = false;
    getBoxStudentPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) setBoxStudentPage(data);
      })
      .catch(() => {
        if (!cancel) {
          setBoxStudentPage(null);
          setHasError(true);
        }
      });
    return () => {
      cancel = true;
    };
  }, [locale]);

  const isProcessingPayment =
    isLoadingPayment || isLoadingGettingPaymentInProcess || isLoadingPaymentInfo;

  const renderTerminarButton = (monedaId: number, label: string) => (
    <ButtonPrimaryStyled
      type="primary"
      disabled={isLoading || paymentStarted}
      size="large"
      onClick={() => obtenerValidaciones(monedaId, "card")}
      loading={isProcessingPayment}
    >
      {label}
    </ButtonPrimaryStyled>
  );

  const renderPaymentMethodPicker = (monedaId: number) => (
    <PaymentMethodSelector
      content={boxStudentPage}
      disabled={isLoading || paymentStarted}
      loadingMethod={isProcessingPayment ? paymentMethod : null}
      onSelect={(method) => obtenerValidaciones(monedaId, method)}
    />
  );

  const renderCurrencyChoice = () => (
    <ButtonsContainer>
      <ButtonPrimaryStyled type="primary" size="large" onClick={() => setSelectedCurrency(188)}>
        {boxStudentPage?.pay_colones_button || "Pagar cargos en colones"}
      </ButtonPrimaryStyled>
      <ButtonPrimaryStyled type="primary" size="large" onClick={() => setSelectedCurrency(840)}>
        {boxStudentPage?.pay_dollars_button || "Pagar cargos en dólares"}
      </ButtonPrimaryStyled>
    </ButtonsContainer>
  );

  const renderCurrencyPicker = (monedaId: number) => (
    <>
      <ChangeCurrencyButtonStyled type="button" onClick={() => setSelectedCurrency(null)}>
        <Icon name="arrow_back" /> {boxStudentPage?.change_currency_button || "Cambiar moneda"}
      </ChangeCurrencyButtonStyled>
      {renderPaymentMethodPicker(monedaId)}
    </>
  );

  const invoiceHeader = (
    <>
      <CardsGroup
        extraContent={
          <>
            <CardUserInvoiceName direction="vertical">
              <CardTitle style={{ fontSize: "18px" }}>{boxStudentPage?.bill_name || "Factura a nombre de"}</CardTitle>
              <Flex>
                <CardText>
                  {isLoading ? "...Cargando" : cartInfo?.data?.estudianteTercero?.terceroNombre}
                </CardText>{" "}
                <Button
                  disabled={isLoading}
                  size="small"
                  type="link"
                  onClick={() => setModalInvoiceData(true)}
                >
                  {boxStudentPage?.change_button || "Cambiar"}
                </Button>
              </Flex>
            </CardUserInvoiceName>
            <CartMoneyInfo
              cargosMonedas={cargosMonedas}
              totalCuotas={totalCuotas}
              totalPendiente={totalPendiente}
              reglaEstimacion={cartInfo?.data?.regla?.reglaEstimada}
            />

            <ThirdPersonForm
              initialValues={cartInfo?.data?.estudianteTercero}
              open={modalInvoiceData}
              savePerson={savePerson}
              isLoading={isLoadingSavingPerson}
              onCancel={() => {
                setModalInvoiceData(false);
              }}
            />
          </>
        }
      />
    </>
  );

  const terminarColones =
    cargosMonedas.colones &&
    totalAmountCol < 0.1 &&
    (cartInfo?.data?.asignaturas?.length > 0 ||
      cartInfo?.data?.servicios?.length > 0 ||
      (cartInfo?.data?.colones?.deuda?.saldoNoVencido > 0 &&
        (form.saldoAFavorAUsarColones ?? 0) > 0) ||
      (cartInfo?.data?.colones?.deuda?.saldoVencido > 0 &&
        (form.saldoAFavorAUsarColones ?? 0) > 0));
  const pagarColones = cargosMonedas.colones && totalAmountCol > 0.1;

  const terminarDolares =
    cargosMonedas.dolares &&
    totalAmountDol < 0.1 &&
    (cartInfo?.data?.asignaturas?.length > 0 ||
      cartInfo?.data?.servicios?.length > 0 ||
      (cartInfo?.data?.dolares?.deuda?.saldoNoVencido > 0 &&
        (form.saldoAFavorAUsarDolar ?? 0) > 0) ||
      (cartInfo?.data?.dolares?.deuda?.saldoVencido > 0 && (form.saldoAFavorAUsarDolar ?? 0) > 0));
  const pagarDolares = cargosMonedas.dolares && totalAmountDol > 0.1;

  const steps: IRegisterStepProps[] = [
    {
      id: 0,
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (enrollmentPage?.subtitleTR || "Carrito"),
      component: (
        <>
          {invoiceHeader}

          <FlexStyled>
            <CartResumeContainerStyled>
              {cartInfo?.data?.asignaturas?.length > 0 && (
                <ResumeList
                  programas={cartInfo?.data?.carreras}
                  isLoading={isLoading}
                  marcarParaCuotas={marcarParaCuotas}
                  viewHeight="40vh"
                  title={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 250 }} /> : (userEnrollementPage?.cart_selection?.subject_selected || "Materia(s) seleccionada(s):")}
                  listType="subject"
                  listItems={
                    cartInfo?.data?.asignaturas?.map((a: ICartItem & { carreraId: number }) => ({
                      ...a,
                      reglaTipoId: cartInfo?.data?.regla?.reglaTipoId,
                      programaId: a.carreraId,
                      pagaCuotas:
                        materiasCuotas.find((mat) => mat.id == a.matriculaId) !== undefined,
                    })) as ICartItem[]
                  }
                  items={itemsSubjects}
                />
              )}
              <br />
              {cartInfo?.data?.servicios?.length > 0 && (
                <ResumeList
                  isLoading={isLoading}
                  viewHeight="30vh"
                  title={boxStudentPage?.services_title || "Servicios:"}
                  listType="service"
                  listItems={cartInfo?.data?.servicios as ICartItem[]}
                  items={itemsServices}
                />
              )}
              <br />
              {getExtendButton()}
            </CartResumeContainerStyled>
            <ImageButtonContainerStyled>
              <Image src={PaymentSVG} width={300} preview={false} style={{ margin: "50px 0px" }} />
              <br />
              <br />
              <ButtonsContainer>
                {previous !== "general" && (
                  <ButtonAlternativeStyled
                    onClick={() =>
                      navigate(
                        previous === "selection"
                          ? `/subjects-registration/${
                              cartInfo?.data?.carreras?.length == 1
                                ? cartInfo?.data?.carreras[0].carreraId
                                : "initial"
                            }`
                          : "/requests",
                      )
                    }
                    type="default"
                    size="large"
                  >
                    {" "}
                    {userEnrollementPage?.back_button || "Atrás"}
                  </ButtonAlternativeStyled>
                )}
                {((cartInfo?.data?.asignaturas?.length ?? 0) > 0 ||
                  (cartInfo?.data?.servicios?.length ?? 0) > 0 ||
                  cartInfo?.data?.colones?.deuda?.saldoNoVencido > 0 ||
                  cartInfo?.data?.colones?.deuda?.saldoVencido > 0 ||
                  cartInfo?.data?.dolares?.deuda?.saldoNoVencido > 0 ||
                  cartInfo?.data?.dolares?.deuda?.saldoVencido > 0) && (
                  <ButtonPrimaryStyled
                    type="primary"
                    disabled={isLoading}
                    size="large"
                    onClick={() => setCurrentStep(currentStep + 1)}
                  >
                    {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (userEnrollementPage?.next_button || "Siguiente")}
                  </ButtonPrimaryStyled>
                )}
              </ButtonsContainer>
            </ImageButtonContainerStyled>
            {isLoading || isLoadingPayment || isLoadingDeleting ? (
              <>
                <ResumeCardStyled>
                  <ResumeFlexStyled>
                    <Skeleton.Image active />
                    <Skeleton loading={true} active round title={false} />
                  </ResumeFlexStyled>
                </ResumeCardStyled>
                <br />
              </>
            ) : (!cartInfo?.data?.asignaturas && !cartInfo?.data?.servicios) ||
              (cartInfo?.data?.asignaturas?.length == 0 &&
                cartInfo?.data?.servicios?.length == 0) ? (
              <>
                <BillBoxStyled>
                  <Segmented
                    options={[
                      { label: boxStudentPage?.currency_colones_option || "Colones", value: 1 },
                      { label: boxStudentPage?.currency_dollars_option || "Dolares", value: 2 },
                    ]}
                    size="large"
                    style={{ marginBottom: "10px" }}
                    defaultValue={1}
                    onChange={(e) => {
                      e == 1
                        ? setCargosMonedas({ colones: true, dolares: false })
                        : setCargosMonedas({ colones: false, dolares: true });
                    }}
                  />
                  <Bill
                    hayMateriasOServicios={
                      cartInfo?.data?.asignaturas?.length > 0 ||
                      cartInfo?.data?.servicios?.length > 0
                    }
                    esPagoAFavor={cartInfo?.data?.servicios?.length > 0 ? false : true}
                    conversion={cartInfo?.data?.conversion}
                    limiteCuotas={cartInfo?.data?.numeroCuotas}
                    actualizarPagosCuotas={changePastFeesGettingPaid}
                    hayCargosEnColones={cargosMonedas.colones}
                    hayCargosEnDolares={cargosMonedas.dolares}
                    dataTransferencia={
                      cartInfo?.data?.colones?.descuento?.transferencia ??
                      cartInfo?.data?.dolares?.descuento?.transferencia
                    }
                    setTotalAmountColones={(num: number) => setTotalAmountCol(num)}
                    setTotalAmountDolares={(num: number) => setTotalAmountDol(num)}
                    totalPendienteColones={totalPendiente.colones}
                    totalPendienteDolares={totalPendiente.dolares}
                    setTotalPendienteColones={(num: number) =>
                      setTotalPendiente({ ...totalPendiente, colones: num })
                    }
                    setTotalPendienteDolares={(num: number) =>
                      setTotalPendiente({ ...totalPendiente, dolares: num })
                    }
                    totalCuotas={totalCuotas}
                    pagoCuotas={materiasCuotas.length > 0}
                    setValue={(obj) => setForm({ ...form, ...obj })}
                    billColones={{
                      ...cartInfo?.data?.colones?.deuda,
                      ...cartInfo?.data?.colones?.descuento,
                      ...cartInfo?.data?.colones?.pago,
                    }}
                    billDolares={{
                      ...cartInfo?.data?.dolares?.deuda,
                      ...cartInfo?.data?.dolares?.descuento,
                      ...cartInfo?.data?.dolares?.pago,
                    }}
                  />
                  <br />
                  <Card>
                    <Checkbox
                      onChange={(e) => setAceptaTerminos(e.target.checked)}
                      defaultChecked={aceptaTerminos}
                    >
                      <Text style={{ fontWeight: "bold" }}>{boxStudentPage?.acept || "Acepto los "}</Text>

                      <Button type="link" onClick={() => mostrarTerminos()} style={{ padding: 0 }}>
                        {boxStudentPage?.aceptterms || "términos y condiciones."}
                      </Button>
                    </Checkbox>
                  </Card>
                  <div>
                    {!isUserImpersonated && (cargosMonedas.colones || cargosMonedas.dolares) && (
                      <>
                        {cargosMonedas.colones && cargosMonedas.dolares
                          ? selectedCurrency
                            ? renderCurrencyPicker(selectedCurrency)
                            : renderCurrencyChoice()
                          : renderPaymentMethodPicker(cargosMonedas.colones ? 188 : 840)}
                      </>
                    )}
                    {getPresentialPaymentVisible() && !isUserImpersonated && (
                      <ButtonsContainer>
                        <ButtonAlternativeStyled
                          style={{ width: "100%" }}
                          onClick={() => {
                            if (aceptaTerminos) {
                              AssignCartToCashier(materiasCuotas?.map((ma) => ma.id));
                            } else {
                              toast(
                                boxStudentPage?.terms_required_payment_message ||
                                "Debe aceptar los términos para procesar el pago.",
                                toastErrorStyle,
                              );
                            }
                          }}
                          loading={isLoadingCartToCashier}
                        >
                          {boxStudentPage?.pay_presential_button || "Realizaré el pago presencialmente en caja"}
                        </ButtonAlternativeStyled>
                      </ButtonsContainer>
                    )}
                  </div>
                </BillBoxStyled>
              </>
            ) : null}
          </FlexStyled>
          {contextHolderTerminos}
        </>
      ),
    },
    {
      id: 1,
      title: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 250 }} /> : (enrollmentPage?.subtitleF || "Caja"),
      component: (
        <>
          {invoiceHeader}
          <FlexStyled>
            <div>
              <Image src={PaymentSVG} width={400} preview={false} style={{ margin: "100px 0px" }} />
              {getExtendButton()}
            </div>
            <FlexStyled style={{ gap: "20px" }}>
              {cuotasPasadas?.length > 0 && (
                <ScrollView
                  height={"710px"}
                  style={{ width: "100%", minWidth: "120px", textAlign: "center" }}
                >
                  <>
                    <SmallHeadingStyled style={{ textAlign: "center" }}>
                      {boxStudentPage?.pending_fees_title || "Cuotas pendientes"}
                    </SmallHeadingStyled>
                    {cuotasPasadas.map((fee) => (
                      <FeesContainerStyled key={fee.id}>
                        <h5>{fee.descripcion}</h5>
                        <span>
                          {fee.moneda === 2 ? "₡" : "$"}
                          {FormatterUtils.number(fee.saldo.toFixed(2))}
                        </span>
                        <br />
                        <br />
                        {isDisplayableDate(fee.fechaVencimiento) ? (
                          <span style={{ color: "#00479B", fontSize: "12px" }}>
                            {boxStudentPage?.due_date_label || "Vence:"} {formatDate(fee.fechaVencimiento)}
                          </span>
                        ) : null}
                      </FeesContainerStyled>
                    ))}
                  </>
                </ScrollView>
              )}
              <BillBoxStyled>
                <Bill
                  esPagoAFavor={false}
                  hayMateriasOServicios={
                    cartInfo?.data?.asignaturas?.length > 0 || cartInfo?.data?.servicios?.length > 0
                  }
                  conversion={cartInfo?.data?.conversion}
                  limiteCuotas={cartInfo?.data?.numeroCuotas}
                  actualizarPagosCuotas={changePastFeesGettingPaid}
                  hayCargosEnColones={cargosMonedas.colones}
                  hayCargosEnDolares={cargosMonedas.dolares}
                  dataTransferencia={
                    cartInfo?.data?.colones?.descuento?.transferencia ??
                    cartInfo?.data?.dolares?.descuento?.transferencia
                  }
                  setTotalAmountColones={(num: number) => setTotalAmountCol(num)}
                  setTotalAmountDolares={(num: number) => setTotalAmountDol(num)}
                  totalPendienteColones={totalPendiente.colones}
                  totalPendienteDolares={totalPendiente.dolares}
                  setTotalPendienteColones={(num: number) =>
                    setTotalPendiente({ ...totalPendiente, colones: num })
                  }
                  setTotalPendienteDolares={(num: number) =>
                    setTotalPendiente({ ...totalPendiente, dolares: num })
                  }
                  totalCuotas={totalCuotas}
                  pagoCuotas={materiasCuotas.length > 0}
                  setValue={(obj) => setForm({ ...form, ...obj })}
                  billColones={{
                    ...cartInfo?.data?.colones?.deuda,
                    ...cartInfo?.data?.colones?.descuento,
                    ...cartInfo?.data?.colones?.pago,
                  }}
                  billDolares={{
                    ...cartInfo?.data?.dolares?.deuda,
                    ...cartInfo?.data?.dolares?.descuento,
                    ...cartInfo?.data?.dolares?.pago,
                  }}
                />
                <br />
                <Card>
                  <Checkbox
                    onChange={(e) => setAceptaTerminos(e.target.checked)}
                    defaultChecked={aceptaTerminos}
                  >
                    <Text style={{ fontWeight: "bold" }}>{boxStudentPage?.acept || "Acepto los "}</Text>

                    <Button type="link" onClick={() => mostrarTerminos()} style={{ padding: 0 }}>
                      {boxStudentPage?.aceptterms || "términos y condiciones."}
                    </Button>
                  </Checkbox>
                </Card>
                <div>
                  <ButtonsContainer>
                    <ButtonAlternativeStyled
                      onClick={() => setCurrentStep(currentStep - 1)}
                      type="default"
                      size="large"
                    >
                      {" "}
                      {userEnrollementPage?.back_button || "Atrás"}
                    </ButtonAlternativeStyled>
                    {!isUserImpersonated && (
                      <>
                        {terminarColones &&
                          renderTerminarButton(188, boxStudentPage?.finish_colones_button || "Terminar ₡")}
                        {terminarDolares &&
                          renderTerminarButton(840, boxStudentPage?.finish_dollars_button || "Terminar $")}
                      </>
                    )}
                  </ButtonsContainer>
                  {!isUserImpersonated && (pagarColones || pagarDolares) && (
                    <>
                      {pagarColones && pagarDolares
                        ? selectedCurrency
                          ? renderCurrencyPicker(selectedCurrency)
                          : renderCurrencyChoice()
                        : renderPaymentMethodPicker(pagarColones ? 188 : 840)}
                    </>
                  )}
                  {getPresentialPaymentVisible() && !isUserImpersonated && (
                    <ButtonsContainer>
                      <ButtonAlternativeStyled
                        style={{ width: "100%" }}
                        onClick={() => {
                          if (aceptaTerminos) {
                            AssignCartToCashier(materiasCuotas?.map((ma) => ma.id));
                          } else {
                            toast(
                              boxStudentPage?.terms_required_payment_message ||
                                "Debe aceptar los términos para procesar el pago.",
                              toastErrorStyle,
                            );
                          }
                        }}
                        loading={isLoadingCartToCashier}
                      >
                        {boxStudentPage?.pay_presential_button || "Realizaré el pago presencialmente en caja"}
                      </ButtonAlternativeStyled>
                    </ButtonsContainer>
                  )}
                </div>
              </BillBoxStyled>
            </FlexStyled>
          </FlexStyled>
          {contextHolderTerminos}
        </>
      ),
    },
  ];

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setUserEnrollementPage(null);
        setEnrollmentPage(null);
      }}
    />;
  }

  return (
    <Box style={{ maxWidth: 1440 }}>
      <SectionHeaderStyled style={{ height: isMobile ? "75px" : "35px", padding: 0 }}>
        <CartHeadingStyled>{currentStep == 0 ? isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (enrollmentPage?.subtitleTR || "Carrito") : boxStudentPage?.title || "Caja"}</CartHeadingStyled>
      </SectionHeaderStyled>
      {getTimeLeft()}
      {steps.find((st) => st.id === currentStep)?.component}
      {contextHolder}

      <CreditCardForm
        content={boxStudentPage}
        open={showCardForm}
        onSubmit={handleCardSubmit}
        onCancel={() => {
          setShowCardForm(false);
          setPaymentStarted(false);
        }}
        isLoading={isLoadingPaymentInfo}
        hasOverdueBalance={
          cartInfo?.data?.colones?.deuda?.saldoVencido > 0 ||
          cartInfo?.data?.dolares?.deuda?.saldoVencido > 0
        }
        totalAmount={chargeAmount}
        currencySymbol={pendingCurrency === 188 ? "\u20A1" : "$"}
        cardholderName={userInfo.fullName}
        paymentPlans={availablePaymentPlans}
        isLoadingPaymentPlans={isLoadingPaymentPlans}
      />

      <ThreeDSModal
        content={boxStudentPage}
        open={!!iframeContent}
        iframeContent={iframeContent}
        isCompletingPayment={isLoadingCompletingPayment}
      />

      <BacSimplePayForm
        content={boxStudentPage}
        open={showBacForm}
        totalAmount={chargeAmount}
        currencySymbol={pendingCurrency === 188 ? "₡" : "$"}
        people={userInfo.id}
        cedula={userInfo.cedula}
        defaultPhone={userInfo.telefono}
        onSuccess={(pagoId) => {
          setShowBacForm(false);
          toast.success(boxStudentPage?.payment_success_message || "Pago realizado correctamente", toastSuccessStyle);
          navigate(`/last-receipt/${pagoId}/${null}`);
        }}
        onCancel={() => {
          setShowBacForm(false);
          setPaymentStarted(false);
        }}
      />
    </Box>
  );
};

export default Payments;
